"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var react_1 = require("react");
var theme_1 = __importDefault(require("../../../styles/theme"));
var Popper_style_1 = __importStar(require("./Popper.style"));
/**
 * Popper atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-popper--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Popper Source}
 */
var Popper = function (_a) {
    var anchorEl = _a.anchorEl, _b = _a.arrow, arrow = _b === void 0 ? false : _b, children = _a.children, className = _a.className, _c = _a.noFlip, noFlip = _c === void 0 ? false : _c, offset = _a.offset, _d = _a.onClickAway, onClickAway = _d === void 0 ? lodash_1.noop : _d, open = _a.open, placement = _a.placement, _e = _a.positionFixed, positionFixed = _e === void 0 ? false : _e, _f = _a.secondaryOffset, secondaryOffset = _f === void 0 ? 0 : _f, _g = _a.zIndex, zIndex = _g === void 0 ? theme_1.default.zIndex.dropdown : _g;
    var classes = (0, Popper_style_1.default)({ zIndex: zIndex });
    var _h = __read((0, react_1.useState)(null), 2), arrowRef = _h[0], setArrowRef = _h[1];
    var primaryOffset = (arrow ? Popper_style_1.arrowSize : 0) + (offset !== null && offset !== void 0 ? offset : 0);
    return ((0, jsx_runtime_1.jsxs)(core_1.Popper, __assign({ open: open, className: classes.popper, anchorEl: anchorEl, placement: placement, popperOptions: {
            positionFixed: positionFixed,
        }, modifiers: {
            offset: {
                enabled: true,
                offset: "".concat(secondaryOffset, ", ").concat(primaryOffset),
            },
            flip: {
                enabled: !noFlip,
            },
            preventOverflow: {
                enabled: !noFlip,
                boundariesElement: 'viewport',
            },
            arrow: {
                enabled: arrow,
                element: arrowRef,
            },
            hide: {
                enabled: !noFlip,
            },
        } }, { children: [arrow && (0, jsx_runtime_1.jsx)("span", { className: classes.arrow, ref: setArrowRef }), (0, jsx_runtime_1.jsx)(core_1.ClickAwayListener, __assign({ onClickAway: onClickAway }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.root, className) }, { children: children })) }) }))] })));
};
exports.Popper = Popper;
